import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { rebuildRideDetails } from '../api/services/Rides';
import { RebuildRidePayload } from '../types/rides';

interface iUseRebuildRideSubmit {
  rideSlug: string;
  successCallback?: (data) => void;
  errorCallback?: (
    error:
      | Error & {
          errors: string[];
        }
  ) => void;
}

export const useRebuildRideSubmit = ({ rideSlug, successCallback, errorCallback }: iUseRebuildRideSubmit) => {
  return useApiSend(
    (payload: RebuildRidePayload) => rebuildRideDetails(rideSlug, payload),
    successCallback,
    errorCallback,
    [],
    undefined
  );
};
